<div class="backspinner" *ngIf="mode === 'indeterminate'">
  <div class="spinner-border" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>
<!-- *ngIf="adjustheight()" -->
<mat-horizontal-stepper labelPosition="bottom" [linear]="true" (selectionChange)="selectionChange($event)"
  [selectedIndex]="selectedIndex" #stepper>
  <mat-step [completed]="logstatus === true">

    <ng-template matStepLabel>Signin/Register</ng-template>
    <!--      <mat-form-field>-->
    <mat-tab-group *ngIf="logstatus === false">
      <mat-tab label="Sign In">
        <form class="checkout-login" [formGroup]="loginForm">
          <div class="form-group">
            <label>Email</label>
            <div class="inputgroup">
              <input type="email" placeholder="Email ID" formControlName="email"
                [ngClass]="{ 'is-invalid': submitted && signinFormData.email.errors }" (keyup)="keyUp($event)">
              <i class="icon-email"></i>
              <div *ngIf="submitted && signinFormData.email.errors" class="invalid-feedback">
                <div *ngIf="signinFormData.email.errors.required">Please enter your email address in the format
                  yourname@example.com</div>
              </div>

            </div>
          </div>
          <div class="form-group">
            <label>Password</label>
            <div class="inputgroup">
              <input type="password" placeholder="Password" formControlName="password"
                [ngClass]="{ 'is-invalid': submitted && signinFormData.password.errors }">
              <i class="icon-lock"></i>
              <div *ngIf="submitted && signinFormData.password.errors" class="invalid-feedback">
                <div *ngIf="signinFormData.password.errors.required">Please enter a password</div>
              </div>

            </div>
            <div class="" style="color: #dc3545;font-size: 11px;" *ngIf="errorMsg !== ''">
              {{errorMsg}}
            </div>
            <div class="" style="color: #dc3545;font-size: 11px;" *ngIf="wrongPassword !== ''">
              {{wrongPassword}}
            </div>
          </div>
          <!-- <div class="text-right forget-link">
            <a href="javascript:void(0)" class="text-underline">Forgot Password?</a>
          </div> -->
          <div class="form-btn">
            <button class="btn" (click)="onSubmit()" type="submit">Log In</button>
          </div>
          <!--          <div class="divider text-center"><span>or</span></div>-->
          <!--          <div class="other-login-btns">-->
          <!--            <a href="#" class="facebook-btn d-block d-md-inline-block"><i class="icon-facebook"></i>Facebook</a>-->
          <!--            <a class="google-btn d-block d-md-inline-block" href="#"><i class="icon-google"></i>Google</a>-->
          <!--          </div>-->
        </form>
      </mat-tab>
      <mat-tab label="Register" *ngIf="logstatus === false">
        <form class="checkout-login" [formGroup]="registerFormUser" (ngSubmit)="onSubmitUserForm()">
          <div class="form-group">
            <label>First Name</label>
            <input type="text" placeholder="First Name" formControlName="firstName"
              [ngClass]="{ 'is-invalid': submitted && formData.firstName.errors }"
              onkeypress='return (event.which > 64 && event.which < 91) || (event.which > 96 && event.which < 123) || event.which == 8 || event.which == 46'>
            <div *ngIf="submitted && formData.firstName.errors" class="invalid-feedback">
              <div *ngIf="formData.firstName.errors.required">Please enter your first name</div>
              <div *ngIf="formData.firstName.errors.minlength">
                Please enter atleast 3 charcaters.
              </div>
            </div>
          </div>
          <div class="form-group">
            <label>Last Name</label>
            <input type="text" placeholder="Last Name" formControlName="lastName"
              [ngClass]="{ 'is-invalid': submitted && formData.lastName.errors }"
              onkeypress='return (event.which > 64 && event.which < 91) || (event.which > 96 && event.which < 123) || event.which == 8 || event.which == 46'>
            <div *ngIf="submitted && formData.lastName.errors" class="invalid-feedback">
              <div *ngIf="formData.lastName.errors.required">Please enter your last name</div>
              <div *ngIf="formData.lastName.errors.minlength">
                Please enter atleast 3 charcaters.
              </div>
            </div>
          </div>
          <div class="form-group">
            <label>Email Id</label>
            <input type="email" placeholder="Email Id" formControlName="email"
              [ngClass]="{ 'is-invalid': submitted && formData.email.errors }">
            <div *ngIf="submitted && formData.email.errors" class="invalid-feedback">
              <div
                *ngIf="formData.email.errors.required || formData.email.errors.email || formData.email.errors.passwordValid">
                Please enter your email address in the format yourname@example.com</div>
              <!-- <div *ngIf="formData.email.errors.email">Email must be a valid email address</div> -->
              <!-- <div *ngIf="formData.email.errors.emailDomain">Please Enter Your Email ID</div> -->
              <!-- <div *ngIf="formData.email.errors.pattern">The email address must contain at least the @ character</div> -->
            </div>
            <div class="invalid-feedback" *ngIf="errorMessageEmail?.length > 0" style="display: block;">
              {{ errorMessageEmail }}
            </div>
          </div>
          <!--          <div class="form-group">-->
          <!--            <label>Mobile</label>-->
          <!--            <input  maxlength="10"-->
          <!--                    onkeypress='return (event.which > 47 && event.which <= 57) || event.which == 8 || event.which == 46'-->
          <!--                    type="text" formControlName="mobile" placeholder="9876543210"-->
          <!--                    [ngClass]="{ 'is-invalid': submitted && formData.mobile.errors }">-->
          <!--            <div *ngIf="submitted && formData.mobile.errors" class="invalid-feedback">-->
          <!--              <div *ngIf="formData.mobile.errors.required">Mobile is required</div>-->
          <!--              <div *ngIf="formData.mobile.errors.minlength && formData.mobile.errors.maxlength">Number must be at least-->
          <!--                10 characters</div>-->
          <!--            </div>-->
          <!--          </div>-->
          <div class="form-group">
            <label>Password</label>
            <input type="password" formControlName="password" placeholder="Password" id="pass"
              [ngClass]="{ 'is-invalid': submitted && formData.password.errors }"
              (keyup)="checkpasswordvalid($event.target.value)">
            <div *ngIf="submitted && formData.password.errors" class="invalid-feedback">
              <div *ngIf="formData.password.errors.required">Please enter a password</div>
            </div>
            <div class="invalid-feedback" style="display: block">{{passerr2}}</div>
          </div>
          <div class="form-group">
            <label>Confirm Password</label>
            <input type="password" formControlName="conpassword" placeholder="Confirm Password" id='confirmpass'
              [ngClass]="{ 'is-invalid': submitted && formData.conpassword.errors }" (keyup)="checkpassword()">

            <div *ngIf="submitted && formData.conpassword.errors" class="invalid-feedback">
              <div *ngIf="formData.conpassword.errors.required">Please re-enter your password</div>
            </div>
            <div class="invalid-feedback" style="display: block" *ngIf="!confirmpass">Please check that your passwords
              match</div>
          </div>

          <!--          <div class="text-right forget-link">-->
          <!--            <a href="javascript:void(0)">Forgot Password?</a>-->
          <!--          </div>-->
          <p class="signup-terms">By signing up, I agree to My Life Well <a href="/terms-conditions">Terms of
              Service</a>,
            <!--&lt;!&ndash;          <a href="#">Cancellation Policies</a>, -->
            and <a href="/privacy_policy">Privacy</a>.
          </p>
          <div class="form-btn">
            <button class="btn ">Submit</button>
          </div>
        </form>
      </mat-tab>
    </mat-tab-group>
    <div class="text-center text-md-right">
      <!--      <button mat-button matStepperPrevious>Back</button>-->
      <!--      <button class="step-continue btn" mat-button matStepperNext><span>Continue <i class="icon-arrow"></i></span></button>-->
    </div>

  </mat-step>
  <mat-step *ngIf="(macro && macro.travelerDetailsPage) && logstatus == true">

    <ng-template matStepLabel>Traveller Details</ng-template>
    <!--      <mat-form-field>-->
    <div class="traveller-details">
      <div class="traveller-slider text-center">

        <div class="traveller-item " *ngFor="let traveldat of travellerDataFromAPi;let i = index">
          <h5 class="item-title">{{traveldat.name}}</h5>
          <p class="time-frame">{{traveldat.itineraryData.date}}</p>
          <address class="location"><i class="icon-add"></i> {{traveldat.country.name}}</address>
        </div>

      </div>
      <div class="traveller-slider2 formClassCheck">

        <div class="insidetraveller-slider2"
          *ngFor="let traveldat of travellerDataFromAPi; let i = index;let last=last;">
          <div *ngFor="let j of singleprogramperson[i]; let k =index">
            <div id="form_{{i}}_{{k}}">
              <h4 class="traveller-title">
                Traveler Details {{k+1}}
              </h4>
              <form class="checkout-login " id="actform_{{i}}_{{k}}">
                <div class="fld-wrap">
                  <div class="form-group">
                    <label>
                      Your Name
                      <span *ngIf="k === 0">*</span>
                    </label>
                    <input id="name_{{i}}_{{k}}" type="text" placeholder="Your Name" [required]="k === 0"
                      onkeypress='return (event.which > 64 && event.which <= 91   ) || event.which == 8 || event.which == 32 || (event.which > 96 && event.which < 123) '>
                    <div *ngIf="k==0" id="error-dynamic1{{i}}" [ngStyle]="{'color':'#dc3545'}">
                    </div>
                  </div>
                  <div class="form-group">
                    <label>
                      Age
                      <span *ngIf="k === 0">*</span>
                    </label>
                    <input id="age_{{i}}_{{k}}" type="text" min="1" max="100" placeholder="Age"
                      onkeypress='return (event.which > 47 && event.which <= 57) || event.which == 8 || event.which == 46'
                      maxlength="2" [required]="k === 0">
                    <div *ngIf="k==0" id="error-dynamic2{{i}}" [ngStyle]="{'color':'#dc3545'}">
                    </div>
                  </div>
                  <div class="form-group">
                    <label>
                      Email Id
                      <span *ngIf="k === 0">*</span>
                    </label>
                    <input id="email_{{i}}_{{k}}" type="text" placeholder="Email ID" [required]="k === 0"
                      pattern="/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/">
                    <div *ngIf="k==0" id="error-dynamic3{{i}}" [ngStyle]="{'color':'#dc3545'}">
                    </div>
                  </div>
                  <div class="form-group">
                    <label>
                      Mobile
                      <span *ngIf="k === 0">*</span>
                    </label>
                    <div class="inputgroup">
                      <input id="mobile_{{i}}_{{k}}" maxlength="10" type="text" placeholder="Mobile"
                        onkeypress='return (event.which > 47 && event.which <= 57) || event.which == 8 || event.which == 46'
                        [required]="k === 0">
                      <!--                      <span class="counry-code">+91</span>-->
                      <div *ngIf="k==0" id="error-dynamic4{{i}}" [ngStyle]="{'color':'#dc3545'}">
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label>Address <span *ngIf="k === 0">*</span></label>
                    <input id="address1_{{i}}_{{k}}" type="text" placeholder="Address Line" [required]="k === 0">
                    <div *ngIf="k==0" id="error-dynamic5{{i}}" [ngStyle]="{'color':'#dc3545'}">
                    </div>
                  </div>

                  <div class="form-group">
                    <label>
                      City
                      <span *ngIf="k === 0">*</span>
                    </label>
                    <input id="city_{{i}}_{{k}}" type="text" placeholder="City"
                      onkeypress='return (event.which > 64 && event.which <= 91   ) || event.which == 8 || event.which == 32 || (event.which > 96 && event.which < 123)'>
                    <div *ngIf="k==0" id="error-dynamic8{{i}}" [ngStyle]="{'color':'#dc3545'}">
                    </div>
                  </div>
                  <div class="form-group">
                    <label>
                      State
                      <span *ngIf="k === 0">*</span>
                    </label>
                    <input id="state_{{i}}_{{k}}" type="text" placeholder="State"
                      onkeypress='return (event.which > 64 && event.which <= 91   ) || event.which == 8 || event.which == 32 || (event.which > 96 && event.which < 123) '>
                    <div *ngIf="k==0" id="error-dynamic6{{i}}" [ngStyle]="{'color':'#dc3545'}">
                    </div>
                  </div>
                  <div class="form-group">
                    <label>Zip/Postal Code<span *ngIf="k === 0">*</span></label>
                    <input id="zip_{{i}}_{{k}}" type="text" placeholder="Zip/Postal Code"
                      onkeypress='return (event.which > 47 && event.which <= 57) || event.which == 8 || event.which == 46'>
                    <div *ngIf="k==0" id="error-dynamic7{{i}}" [ngStyle]="{'color':'#dc3545'}">
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="country">Country</label>

                    <select id="country" id="country_{{i}}_{{k}}">

                      <option *ngFor="let country of countryList; let j = index" [value]="country['name']">
                        {{country['name']}}</option>
                    </select>
                    <div *ngIf="k==0" id="error-dynamic9{{i}}" [ngStyle]="{'color':'#dc3545'}">
                      <span>{{countryMessage}}</span>
                    </div>
                  </div>
                </div>

              </form>
            </div>

          </div>
          <div class="more-field" *ngIf="traveldat.itineraryData.people > 1">
            <button class="more-field-btn btn" (click)="addPeople(i)"
              *ngIf="travellerDataFromAPi[i]['itineraryData']['people']!=travelCount"><span><i class="icon-plus"></i>
                Add More Traveller Details</span></button>
          </div>

        </div>
      </div>
      <div class="form-btn text-center d-md-flex justify-content-md-between">
        <!--            <button class="btn submit-btn">Submit</button>-->
        <button class="step-continue btn" mat-button (click)="checkforalltravellerdata(stepper)"><span>Continue <i
              class="icon-arrow"></i></span></button>
      </div>
    </div>
    <!--      </mat-form-field>-->
    <div class="text-center text-md-right">
      <!--      <button mat-button matStepperPrevious>Back</button>-->

    </div>

    <!--      </mat-form-field>-->

  </mat-step>
  <mat-step *ngIf="macro && macro.addons && logstatus == true">
    <ng-template matStepLabel>Addons</ng-template>
    <section class="cart-section summary-section">
      <div class="container">
        <div class="cart-wrapper d-md-flex justify-content-md-between">
          <div class="cart-details addon-details">
            <div class="inner-addon">
              <ul class="addon-observe">
                <li class="d-flex align-items-center flex-wrap justify-content-between"
                  *ngFor="let addondat of cartaddonsdata">
                  <span class="text-capitalize">{{addondat.title}}</span>
                  <div class="value-cross d-flex justify-content-between">
                    <strong>{{addondat.price | currency:'USD':'symbol':'1.2-2'}}</strong>
                    <a href="javascript:void(0)" (click)="deleteaddon(addondat.id, addondat.cartId)">
                      <i class="icon-cross"></i>
                    </a>
                  </div>
                </li>
                <li class="d-flex align-items-center flex-wrap justify-content-between"
                  *ngIf="cartaddonsdata?.length == 0">
                  <strong>No Addon Selected !</strong>
                </li>
              </ul>
              <!-- <h2>Promotional Addon</h2>
           <ul class="Promotional-info">
               <li class="d-flex align-items-center flex-wrap justify-content-between">
                 <span class="text-capitalize">Add Gold Plan with this order</span>
                 <strong>$50.00</strong>
               </li>
               <li class="d-flex align-items-center flex-wrap justify-content-between">
                 <a href="#" class="add-now">Add it now</a>
                 <div class="d-flex choice-wrap justify-content-between">
                   <label>
                     <input type="radio" name="radio">Yes
                     <span class="radio-check"></span>
                   </label>
                   <label>
                     <input type="radio" name="radio">No
                     <span class="radio-check"></span>
                   </label>
                 </div>
               </li>
            </ul> -->
            </div>
            <div class="d-md-flex justify-content-between">
              <button class="checkout-btn  addon-btn pull-left" *ngIf="macro && macro.travelerDetailsPage"
                matStepperPrevious style="display: inline">
                <span>Back</span>
              </button>
              <button class="checkout-btn addon-btn" style="display: inline" matStepperNext>
                <span>Continue <i class="icon-arrow"></i></span>
              </button>
            </div>
          </div>
          <div class="cart-checkout addon-checkout">
            <div class="final-checkout">
              <h2 class="text-capitalize m-0">Price Details</h2>
              <ul class="total-summary">
                <li class="d-flex justify-content-between align-items-center">
                  <span>Subtotal</span>
                  <strong *ngIf="cartdata && !logstatus">{{subtotal | currency:'USD':'symbol':'1.2-2'}}</strong>
                  <strong *ngIf="logstatus && cartdata">{{subtotal | currency:'USD':'symbol':'1.2-2'}}</strong>
                </li>
                <!-- SHIPPING CHARGE START -->
                <li class="d-flex justify-content-between align-items-center" *ngIf="shippingCharge > 0">
                  <span>Shipping Charge</span>
                  <strong>{{shippingCharge | currency:'USD':'symbol':'1.2-2'}}</strong>
                </li>
                <!-- SHIPPING CHARGE END -->
                <li class="d-flex justify-content-between align-items-center" *ngIf="cartdata && traveladdons > 0">
                  <span>Addons</span>
                  <strong>{{traveladdons | currency:'USD':'symbol':'1.2-2'}}</strong>
                </li>
                <li class="total-info d-flex justify-content-between align-items-center paddingBottomInMobileViewOnly">
                  <strong>Order Total</strong>
                  <strong class="final-price">{{ ( totalamount + (shippingCharge ? shippingCharge : 0) ) |
                    currency:'USD':'symbol':'1.2-2'}}</strong>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div>
      <!-- <button mat-button matStepperPrevious>Back</button>
      <button mat-button matStepperNext>Next</button> -->
    </div>
  </mat-step>
  <mat-step *ngIf="macro && macro.orderSummry">
    <ng-template matStepLabel>Order Summary & Promocode</ng-template>
    <section class="cart-section summary-section">
      <div class="container">
        <div class="cart-wrapper d-flex justify-content-between flex-wrap">
          <div class="cart-details" *ngIf="logstatus && cartdata">
            <!-- <div class="inner-cart d-flex justify-content-between flex-wrap">
             <div class="cart-activity clearfix">
               <figure class="cart-image" *ngIf="cartdata.defaultImage">
                 <img [src]="imagelink + cartdata.defaultImage.path + cartdata.defaultImage.name" [alt]="cartdata.defaultImage.name">
               </figure>
               <div class="content-activity space-more">
                 <h2>{{cartdata.name}}</h2>
                 <span class="d-flex profile-small">
                   <img src="assets/images/activity-images.png" alt="activity images">
                   <span>by Ayesha Billimoria</span></span>
               </div>
             </div>
             <ul class="d-flex justify-content-between cart-observe align-items-center align-items-md-end   flex-wrap">
               <li class="cart-specification d-flex align-items-center flex-wrap justify-content-md-center">
                 <i class="icon-mic"></i>
                 <span class="text-capitalize">Recorded Classes</span>
               </li>
               <li>
                 <strong>$100.00</strong>
               </li>
               <li>
                 <a href="#">
                   <i class="icon-edit"></i>
                   <i class="icon-cross"></i>
                 </a>
               </li>
             </ul>
           </div> -->

            <div class="inner-cart d-flex justify-content-between flex-wrap" *ngFor="let cartdat of cartdata">
              <div class="cart-activity clearfix">
                <figure class="cart-image" *ngIf="cartdat?.defaultImage">
                  <!-- <img [src]="imagelink + cartdat.defaultImage.path + cartdat.defaultImage.name" [alt]="cartdat.defaultImage.name"> -->
                  <img *ngIf="!urlvideo(cartdat?.defaultImage)"
                    [src]="imagelink + cartdat.defaultImage.path + cartdat.defaultImage.name"
                    [alt]="cartdat.defaultImage.name">
                  <img *ngIf="urlvideo(cartdat?.defaultImage)" [src]="cartdat.defaultImage"
                    [alt]="cartdat.defaultImage">
                </figure>
                <div class="content-activity">
                  <h2 data-toggle="tooltip" [title]="cartdat?.name" (click)="clickOnNameRoute(cartdat)"
                    class="cursorHand">
                    {{cartdat?.name}}
                  </h2>
                </div>
                <p *ngIf="cartdat?.type === 'shop'">
                  <span>
                    {{cartdat?.attr?.weight}} {{ cartdat?.attr?.weight ? ' gms' : ''}}
                    {{cartdat?.attr?.size && cartdat?.attr?.weight ? " | ": "" }}
                    {{cartdat?.attr?.size}}
                    {{ cartdat?.attr?.weight && (cartdat?.attr?.size && cartdat?.attr?.color ) ? " | ": "" }}
                    {{cartdat?.attr?.color }}
                    {{ (cartdat?.attr?.weight || cartdat?.attr?.size || cartdat?.attr?.color ) && cartdat?.attr?.flavour
                    ? " | ": "" }}
                    {{cartdat?.attr?.flavour }}
                  </span>
                  <span *ngIf="cartdat?.itineraryData?.quantity">
                    Qty: {{cartdat?.itineraryData?.quantity }}
                  </span>
                  <span *ngIf="!shippingInsideUsaFlag" class="fontSize10"
                    [style.color]="(cartdat?.attr?.shippingOutUSA !== null &&  cartdat?.attr?.shippingOutUSA !== '' && cartdat?.attr?.shippingOutUSA >=0 ) ? '': 'red'">
                    Shipping
                    {{ ( cartdat?.attr?.shippingOutUSA !== null && cartdat?.attr?.shippingOutUSA !== "" &&
                    cartdat?.attr?.shippingOutUSA >=0 ) ? "available !!" : "not available on selected country." }}
                    <span
                      *ngIf="( cartdat?.attr?.shippingOutUSA !== null &&  cartdat?.attr?.shippingOutUSA !== '' && cartdat?.attr?.shippingOutUSA >=0 )">
                      ( {{ cartdat?.attr?.shippingOutUSA | currency:'USD':'symbol':'1.2-2' }} )
                    </span>
                  </span>
                  <span *ngIf="shippingInsideUsaFlag" class="fontSize10"
                    [style.color]="( cartdat?.attr?.shippingInUSA !== null &&  cartdat?.attr?.shippingInUSA !== '' && cartdat?.attr?.shippingInUSA >=0 ) ? '': 'red'">
                    Shipping
                    {{ ( cartdat?.attr?.shippingInUSA !== null && cartdat?.attr?.shippingInUSA !== '' &&
                    cartdat?.attr?.shippingInUSA >=0 ) ? "available !!" : "not available on selected country." }}
                    <span
                      *ngIf="( cartdat?.attr?.shippingInUSA !== null &&  cartdat?.attr?.shippingInUSA !== '' && cartdat?.attr?.shippingInUSA >=0 )">
                      ( {{ cartdat?.attr?.shippingInUSA | currency:'USD':'symbol':'1.2-2' }} )
                    </span>
                  </span>
                </p>
                <p *ngIf="cartdat.type === 'travel'">
                  <span>{{cartdat?.itineraryData?.accommodation}}</span>
                  <span>{{cartdat?.itineraryData?.date}}</span>
                  <span>{{cartdat?.pay === 'fullamount'? 'Full': 'Deposit'}}</span>
                </p>
                <p *ngIf="cartdat.type !== 'travel'">
                  <ng-container *ngFor="let instructor of cartdat.instructors">
                    <span class="d-flex profile-small prof-icon"><span class="prof-icn"><img
                          [src]="imagelink+instructor['image']['path']+instructor['image']['name']"
                          alt="activity images"></span>
                      <span>by {{instructor.firstName}}</span>
                    </span>
                  </ng-container>
                </p>

              </div>
              <ul class="d-flex justify-content-between cart-observe align-items-center  flex-wrap">
                <li class="cart-specification d-flex align-items-center flex-wrap justify-content-md-center">
                  <i class="icon-plane" *ngIf="cartdat?.itineraryData?.type === 'travel'"></i>
                  <!-- <i class="icon-mic" *ngIf="cartdat?.itineraryData?.type !== 'travel'"></i> -->
                  <span class="text-capitalize">
                    {{cartdat?.itineraryData?.categoryName}}
                  </span>
                  <!--                  <a href="#" class="trip-update">Update Trip</a>-->
                </li>
                <li>
                  <strong>
                    {{cartdat?.itineraryData?.totalPayPrice | currency:'USD':'symbol':'1.2-2'}}
                  </strong>
                </li>
                <li>
                  <a (click)="deletecartitemlive(cartdat?.cartId)" class="cursorHand">
                    <i class="icon-cross"></i>
                  </a>
                  <!--                    <i class="icon-edit"></i>-->
                </li>
              </ul>
            </div>
            <!--            <div class="inner-cart d-flex justify-content-between flex-wrap">-->
            <!--              <div class="cart-activity clearfix">-->
            <!--                <figure class="cart-image">-->
            <!--                  <img src="assets/images/yoga-grp.jpg" alt="yoga">-->
            <!--                </figure>-->
            <!--                <div class="content-activity more-space">-->
            <!--                  <h2>Wellbeing Storytime LIVE</h2>-->
            <!--                  <span class="d-flex profile-small"><img src="assets/images/activity-images.png" alt="activity images"><span>by lhahoi</span></span>-->
            <!--                </div>-->
            <!--                <p>July 21,2020 - July 28, 2020</p>-->
            <!--              </div>-->
            <!--              <ul class="d-flex justify-content-between cart-observe align-items-center  flex-wrap align-items-md-end">-->
            <!--                <li class="cart-specification justify-content-md-center d-flex align-items-center flex-wrap">-->
            <!--                  <i class="icon-cam"></i>-->
            <!--                  <span class="text-capitalize"><span class="highlighted"> Live</span> Class</span>-->

            <!--                </li>-->
            <!--                <li>-->
            <!--                  <strong>$7000.00</strong>-->
            <!--                </li>-->
            <!--                <li>-->
            <!--                  <a href="#">-->
            <!--                    <i class="icon-edit"></i>-->
            <!--                    <i class="icon-cross"></i>-->
            <!--                  </a>-->
            <!--                </li>-->
            <!--              </ul>-->
            <!--            </div>-->
            <div class="d-flex justify-content-between flex-wrap handled-steps">
              <button class="checkout-btn addon-btn pull-left "
                *ngIf="macro && macro.travelerDetailsPage || macro && macro.addons" matStepperPrevious
                style="display: inline">
                <span>
                  Back
                </span>
              </button>
              <button class="checkout-btn addon-btn continueCheckoutBtnInMobile" style="display: inline" matStepperNext>
                <span (click)="continueCheckoutClickOnOrderSummary()">
                  Continue Checkout
                  <i class="icon-arrow"></i>
                </span>
              </button>
            </div>
            <!--            <button class="checkout-btn" matStepperNext>-->
            <!--              <span>Continue Checkout  <i class="icon-arrow"></i></span>-->

            <!--            </button>-->
          </div>
          <div class="cart-checkout">
            <div class="final-checkout">
              <h2 class="text-capitalize">Price Details</h2>
              <ul class="total-summary">
                <li class="d-flex justify-content-between align-items-center">
                  <span>Subtotal</span>
                  <strong *ngIf="cartdata && !logstatus">{{subtotal | currency:'USD':'symbol':'1.2-2'}}</strong>
                  <strong *ngIf="logstatus && cartdata">{{subtotal | currency:'USD':'symbol':'1.2-2'}}</strong>
                </li>
                <li class="d-flex justify-content-between align-items-center" *ngIf="cartdata && traveladdons > 0">
                  <span>Addons</span>
                  <strong>{{traveladdons | currency:'USD':'symbol':'1.2-2'}}</strong>
                </li>

                <li class="total-info d-flex justify-content-between align-items-center" *ngIf="discountedAmount">
                  <strong>
                    Discount
                    <!-- <span class="fontSize12"> ( {{ ((discountedAmount/subtotal) * 100) | number:'1.0' }}% off )</span> -->
                    <div *ngIf="couponInfo?.appliedFor">
                      <span class="fontSize12  fontItalic">
                        Applied For {{ couponInfo?.appliedFor }} products.
                      </span>
                    </div>
                    <div *ngIf="couponInfo?.description">
                      <span class="fontSize12  fontItalic">
                        {{ couponInfo?.description }}
                      </span>
                    </div>
                  </strong>
                  <strong class="final-price">{{discountedAmount | currency:'USD':'symbol':'1.2-2'}}</strong>
                </li>
                <li class="total-info d-flex justify-content-between align-items-center" *ngIf="loyalityPointsAmount">
                  <strong>Points Discount</strong>
                  <strong class="final-price">{{loyalityPointsAmount | currency:'USD':'symbol':'1.2-2'}}</strong>
                </li>
                <!-- SHIPPING CHARGE START -->
                <li class="d-flex justify-content-between align-items-center" *ngIf="shippingCharge > 0">
                  <span>Shipping Charge</span>
                  <strong>{{shippingCharge | currency:'USD':'symbol':'1.2-2'}}</strong>
                </li>
                <!-- SHIPPING CHARGE END -->
                <li class="total-info d-flex justify-content-between align-items-center">
                  <strong>Order Total</strong>
                  <strong class="final-price">{{ (totalamount + shippingCharge) |
                    currency:'USD':'symbol':'1.2-2'}}</strong>
                </li>
              </ul>
            </div>
            <div class="final-checkout promo-checkout">
              <h2 class="text-capitalize">Apply Promo Code</h2>
              <!-- <form> -->
              <div class="promo-wrap d-flex align-items-center">
                <input type="text" placeholder="enter promo code here" [(ngModel)]="promoCode">
                <i class="icon-gift"></i>
                <span class="material-icons cursorHand" (click)="cancelPromoCode()" *ngIf="promoCode?.length > 0">
                  clear
                </span>
              </div>

              <sup class="show-msg-promo" *ngIf="showMessageForPromoCode" style="color: #0a5fae;">{{ messageForPromoCode
                }}</sup>
              <button class="promo-submit" (click)="ContinueWithPromoCode()" [disabled]="promoCode?.length == 0">
                Apply Promo Code
              </button>
              <!-- </form> -->
            </div>
            <div class="final-checkout promo-checkout">
              <h2 class="text-capitalize">Apply Points</h2>
              <div class="promo-wrap">
                <sup style="color: black;">
                  Points remaining {{ loyalityPointsOfLoggedInUser }} &nbsp; (USD {{ loyalityPointsOfLoggedInUser/100
                  }})
                </sup>
                <div class="d-flex align-items-center">
                  <input type="text" placeholder="enter loyality points" [(ngModel)]="loyalityPoints">
                  <i class="icon-gift"></i>
                  <span class="material-icons cursorHand" (click)="cancelLoyalityPoints()"
                    *ngIf="loyalityPoints?.length > 0">
                    clear
                  </span>
                </div>
              </div>
              <sup class="show-msg-promo" *ngIf="showMessageForLoyalityPoints" style="color: #0a5fae;">
                {{ messageForLoyalityPoints }}
              </sup>
              <button class="promo-submit applyPointOnlyMobileCss" (click)="ContinueWithLoyalityPoints()"
                [disabled]="loyalityPoints?.length == 0">
                Apply Point
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </mat-step>
  <mat-step *ngIf="macro && macro.payment" [completed]="false">
    <ng-template matStepLabel>Secure Payment</ng-template>
    <section class="cart-section" id="payment">
      <div class="container">
        <div class="cart-wrapper d-flex justify-content-between flex-wrap">
          <div class="cart-details payment-details">
            <h1>Payments Detail</h1>
            <!-- <ul class="card-row d-flex flex-wrap"> -->
            <!-- already comment -->
            <!-- <li>
                        <figure>
                          <img src="assets/images/bank1.png" alt="bank card">
                        </figure>

                      </li> -->
            <!-- already comment end-->
            <!-- <li *ngFor="let card of savedCards; let i = index" (click)="togglecardtick(i,card._id)">
                        <figure>
                          <img src="assets/images/bank2.png" alt="bank card">
                          <span class="card-cvv">{{card.cardType}}</span>
                          <span class="card-no">**************{{card.cardNumber}}</span>
                          <i class="icon-redtick tickcard" style="display: none" [id]="'card_' + i"></i>
                        </figure>
                      </li> -->
            <!-- already comment -->
            <!-- <li>
                        <figure>
                          <img src="assets/images/bank3.png" alt="bank card">
                        </figure>
                      </li> -->
            <!-- already comment end-->
            <!-- </ul>
                    <span class="secure-info">100% safe and secure</span> -->
            <div class="payment-form savepayment-form">
              <div *ngIf="addressData  && addressData?.length > 0">
                <div class="floatRight fontSize14 fontWeight600 cursorHand"
                  (click)="this.billingAddressCheck = !this.billingAddressCheck;" style="color: #D23C56;">
                  Select from saved addresses
                </div>
              </div>
            </div>
            <div class="payment-form savepayment-form">

              <form [formGroup]="billing">

                  <div class="inputfield-wrap">
                    <label for="holdername">Full Name</label>
                    <input type="text" id="holdername" formControlName="holdername" placeholder="Jon Smith"
                      [ngClass]="{ 'is-invalid': submitted && bill.holdername.errors }">
                    <div *ngIf="submitted && bill.holdername.errors" class="invalid-feedback">
                      <div *ngIf="bill.holdername.errors.required">
                        Please enter fullname 
                      </div>
                      <div *ngIf="bill.holdername.errors.minlength">
                        Please enter atleast 3 characters
                      </div>
                    </div>
                  </div>
                <!-- <div class="input-grp d-flex justify-content-between flex-wrap">

                          <div class="inputfield-wrap">
                            <label for="holdername">Card Holder Name</label>
                            <input type="text" id="holdername"  formControlName="holdername" placeholder="Card holder name here" [ngClass]="{ 'is-invalid': submitted && bill.holdername.errors }">
                            <div *ngIf="submitted && bill.holdername.errors" class="invalid-feedback">
                              <div *ngIf="bill.holdername.errors.required">
                                Please enter name on credit card
                              </div>
                              <div *ngIf="bill.holdername.errors.minlength">
                                Please enter atleast 3 characters
                              </div>
                            </div>
                          </div>
                          <div class="inputfield-wrap" *ngIf="cardid === '0'">
                            <label for="card-no">Card Number</label>
                            <input type="text" id="card-no" placeholder="2222 5612 3333 7859" (keypress)="chekNumber($event)" formControlName="cardno" [ngClass]="{ 'is-invalid': submitted && bill.cardno.errors }">
                            <i class="icon-date"></i>
                            <div *ngIf="submitted && bill.cardno.errors" class="invalid-feedback">
                              <div *ngIf="bill.cardno.errors.required || bill.cardno.errors.minlength || bill.cardno.errors.maxlength || bill.cardno.errors.pattern">Please enter a valid Card Number</div>
                            </div>
                          </div>
                        </div>
                       

                     
                        <div class="input-grp d-flex justify-content-between flex-wrap" *ngIf="cardid === '0'">
                          <div class="inputfield-wrap ">
                            <label>Expiry Month</label>
                            <select formControlName="expiryMonth" [ngClass]="{ 'is-invalid': submitted && bill.expiryMonth.errors }">
                              <option *ngFor="let m of month" [value]="m">{{m}}</option>
                            </select>
                            <div *ngIf="submitted && bill.expiryMonth.errors" class="invalid-feedback">
                              <div *ngIf="bill.expiryMonth.errors.required">Expiry Month is required</div>
                            </div>
                          </div>
                          <div class="inputfield-wrap  ">
                            <label>Expiry Year</label>
                            <select formControlName="expiryYear" [ngClass]="{ 'is-invalid': submitted && bill.expiryYear.errors }">
                              <option *ngFor="let y of year"  [value]="y">{{y}}</option>
                            </select>
                            <div *ngIf="submitted && bill.expiryYear.errors" class="invalid-feedback">
                              <div *ngIf="bill.expiryYear.errors.required">Expiry Year is required</div>
                            </div>
                          </div>

                        </div>
                          
                        <div class="input-grp d-flex justify-content-between flex-wrap" *ngIf="cardid === '0'">
                          <div class="inputfield-wrap">
                            <label for="cvv">CVV Digit</label>
                            <input type="text" id="cvv" placeholder="989" formControlName="cvv" [ngClass]="{ 'is-invalid': submitted && bill.cvv.errors }" (keypress)="chekNumber($event)">
                            <div *ngIf="submitted && bill.cvv.errors" class="invalid-feedback">
                              <div *ngIf="bill.cvv.errors.required">CVV is required</div>
                            <div *ngIf="bill.cvv.errors.minlength || bill.cvv.errors.maxlength || bill.cvv.errors.pattern">Please enter the security code from your credit card
                            </div>
                            </div>
                          </div>
                          <div class="inputfield-wrap">
                            <label for="contactNumber">Contact Number</label>
                            <input type="text" id="contactNumber" placeholder="9899988776" formControlName="contactNumber" [ngClass]="{ 'is-invalid': submitted && bill.contactNumber.errors }" >
                            <div *ngIf="submitted && bill.contactNumber.errors" class="invalid-feedback">
                              <div *ngIf="bill.contactNumber.errors.required">
                                Contact Number is required
                              </div>
                            </div>
                          </div>

                        </div> -->
                <div class="inputfield-wrap">
                  <label for="address">Billing Address</label>
                  <input type="text" id="address" placeholder="Billing address here" formControlName="address"
                    [ngClass]="{ 'is-invalid': submitted && bill.address.errors }">
                  <div *ngIf="submitted && bill.address.errors" class="invalid-feedback">
                    <div *ngIf="bill.address.errors.required">Please enter the billing address associated with your
                      credit card</div>
                  </div>
                </div>
                <div class="input-grp d-flex justify-content-between flex-wrap">
                  <div class="inputfield-wrap">
                    <label for="city">City</label>
                    <input type="text" id="city" formControlName="city" placeholder="City here"
                      [ngClass]="{ 'is-invalid': submitted && bill.city.errors }">

                    <div *ngIf="submitted && bill.city.errors" class="invalid-feedback">
                      <span *ngIf="bill.city.errors.required" class="validation-message">Please enter the city
                        associated with your credit card</span>
                    </div>
                  </div>
                  <!-- </div> -->
                  <!-- <div class="input-grp d-flex justify-content-between flex-wrap"> -->
                  <div class="inputfield-wrap">
                    <label for="state">State</label>
                    <input type="text" id="state" formControlName="state" placeholder="State here"
                      [ngClass]="{ 'is-invalid': submitted && bill.state.errors }">

                    <div *ngIf="submitted && bill.state.errors" class="invalid-feedback">
                      <span *ngIf="bill.state.errors.required" class="validation-message">*Please enter the state
                        associated with your credit card</span>

                    </div>
                  </div>
                </div>
                <div class="input-grp d-flex justify-content-between flex-wrap">
                  <div class="inputfield-wrap">
                    <label for="zipcode">Zip/Postal Code</label>
                    <input type="text" id="zipcode" placeholder="Zip Code here" formControlName="zipcode"
                      [ngClass]="{ 'is-invalid': submitted && bill.zipcode.errors }">
                    <div *ngIf="submitted && bill.zipcode.errors" class="invalid-feedback">
                      <div *ngIf="bill.zipcode.errors.required">
                        Please enter the zip code associated with your credit card.
                      </div>
                    </div>
                  </div>
                  <div class="inputfield-wrap">
                    <label for="country">Country</label>
                    <!--                            <input type="text" id="country" placeholder="Country here">-->
                    <select id="country" formControlName="country" *ngIf="countryList"
                      [ngClass]="{ 'is-invalid': submitted && bill.country.errors }"
                      (change)="countryChangeInBillingForm($event)">
                      <!--                              <option value="" selected>Please select a country</option>-->
                      <option *ngFor="let country of countryList; let j = index" [value]="country['name']">
                        {{country['name']}}</option>
                    </select>
                    <div *ngIf="submitted && bill.country.errors" class="invalid-feedback">
                      <div *ngIf="bill.country.errors.required">Please enter the country associated with your credit
                        card</div>
                    </div>
                  </div>
                </div>


                <div class="switch-wrap d-flex align-items-center" *ngIf="cardid === '0'">
                  <span>Save my card detail</span>
                  <label class="switch">
                    <input type="checkbox" id="savemycard" checked>
                    <span class="round"></span>
                  </label>
                </div>

              </form>
              <!-- SHIPPING FORM -->
              <div *ngIf="shopProductIncludeInCartData">
                <div class="marginTop5">
                  <h6>
                    Ship to a different Address ?
                    <input type="checkbox" [(ngModel)]="shippingAddressCheck"
                      (change)="shippingAddressCheckCall($event)">
                    <div *ngIf="addressData  && addressData?.length > 0 && shippingAddressCheck" class="">
                      <div class="floatRight fontSize14 fontWeight600 cursorHand"
                        (click)="this.openShippingAddressPopUpFlag = !this.openShippingAddressPopUpFlag;"
                        style="color: #D23C56;">
                        Select from saved addresses
                      </div>
                    </div>
                  </h6>
                </div>
              </div>

              <form [formGroup]="shippingFormGp" *ngIf="shippingAddressCheck">

                <div class="input-grp d-flex justify-content-between flex-wrap">
                  <div class="inputfield-wrap">
                    <label for="FirstName">First Name *</label>
                    <input type="text" id="FirstName" formControlName="FirstName" placeholder="First Name here"
                      [ngClass]="{ 'is-invalid': submittedshippingFormGp && shippingFormControls.FirstName.errors }">
                    <div *ngIf="submittedshippingFormGp && shippingFormControls.FirstName.errors"
                      class="invalid-feedback">
                      <div *ngIf="shippingFormControls.FirstName.errors.required">
                        Please enter first name
                      </div>
                    </div>
                  </div>
                  <div class="inputfield-wrap">
                    <label for="LastName">Last Name *</label>
                    <input type="text" id="LastName" formControlName="LastName" placeholder="Last Name here"
                      [ngClass]="{ 'is-invalid': submittedshippingFormGp && shippingFormControls.LastName.errors }">
                    <div *ngIf="submittedshippingFormGp && shippingFormControls.LastName.errors"
                      class="invalid-feedback">
                      <div *ngIf="shippingFormControls.LastName.errors.required">
                        Please enter last name
                      </div>
                    </div>
                  </div>
                </div>
                <div class="input-grp d-flex justify-content-between flex-wrap">
                  <div class="inputfield-wrap">
                    <label for="Country">Country *</label>
                    <select formControlName="Country" id="Country" (change)="countryChangeInShippingForm($event)">
                      <option *ngFor="let i of countryList" [value]="i['name']">
                        {{ i['name']}}
                      </option>
                    </select>
                    <div *ngIf="submittedshippingFormGp && shippingFormControls.Country.errors"
                      class="invalid-feedback">
                      <div *ngIf="shippingFormControls.Country.errors.required">
                        Please select country
                      </div>
                    </div>
                  </div>
                  <div class="inputfield-wrap">
                    <label for="State">State *</label>
                    <input type="text" id="State" formControlName="State" placeholder="State here"
                      [ngClass]="{ 'is-invalid': submittedshippingFormGp && shippingFormControls.State.errors }">
                    <div *ngIf="submittedshippingFormGp && shippingFormControls.State.errors" class="invalid-feedback">
                      <div *ngIf="shippingFormControls.State.errors.required">
                        Please enter state
                      </div>
                    </div>
                  </div>
                </div>
                <div class="input-grp d-flex justify-content-between flex-wrap">
                  <div class="inputfield-wrap">
                    <label for="City">City *</label>
                    <input type="text" id="City" formControlName="City" placeholder="City"
                      [ngClass]="{ 'is-invalid': submittedshippingFormGp && shippingFormControls.City.errors }">
                    <div *ngIf="submittedshippingFormGp && shippingFormControls.City.errors" class="invalid-feedback">
                      <div *ngIf="shippingFormControls.City.errors.required">
                        Please select city
                      </div>
                    </div>
                  </div>
                  <div class="inputfield-wrap">
                    <label for="Zipcode">Zip/Postal Code *</label>
                    <input type="text" id="Zipcode" placeholder="Zip Code here" formControlName="Zipcode"
                      [ngClass]="{ 'is-invalid': submittedshippingFormGp && shippingFormControls.Zipcode.errors }">
                    <div *ngIf="submittedshippingFormGp && shippingFormControls.Zipcode.errors"
                      class="invalid-feedback">
                      <div *ngIf="shippingFormControls.Zipcode.errors.required">
                        Please enter the zip code
                      </div>
                    </div>
                  </div>
                </div>

                <div class="inputfield-wrap">
                  <label for="ShippingAddress">Shipping Address *</label>
                  <input type="text" id="ShippingAddress" placeholder="shipping address here"
                    formControlName="ShippingAddress"
                    [ngClass]="{ 'is-invalid': submittedshippingFormGp && shippingFormControls.ShippingAddress.errors }">
                  <div *ngIf="submittedshippingFormGp && shippingFormControls.ShippingAddress.errors"
                    class="invalid-feedback">
                    <div *ngIf="shippingFormControls.ShippingAddress.errors.required">
                      Please enter the shipping address
                    </div>
                  </div>
                </div>
              </form>
              <!-- SHIPPING FORM END-->
              <div class="marginTop5 d-flex justify-content-between flex-wrap handled-steps placedbtn-wrap">
                <button class="checkout-btn addon-btn pull-left forMobileViewBackBtnCss" matStepperPrevious
                  style="display: inline">
                  <span>Back</span>
                </button>
                <button class="orderplace-btn forMobileViewPlaceOrderBtnCss" (click)="submitPayment()" type="submit"
                  style="display: inline;" [disabled]="!checkoutButtonFlag"
                  [style.opacity]="checkoutButtonFlag == true ? '': '0.8' "
                  [style.cursor]="checkoutButtonFlag == true ? '': 'not-allowed' ">
                  Place order
                </button>
              </div>
            </div>
          </div>
          <div class="cart-checkout payment-checkout">
            <div class="final-checkout">
              <h2 class="text-capitalize m-0 position-relative">Order Summary
                <!--                      <span class="edit-wrap"><i class="icon-edit"></i>Edit</span>-->
              </h2>
              <ul class="cart-similar">
                <li class="d-flex " *ngFor="let cartdat of cartdata">
                  <figure class="cart-image" *ngIf="cartdat?.defaultImage">
                    <img *ngIf="!urlvideo(cartdat.defaultImage)"
                      [src]="imagelink + cartdat.defaultImage.path + cartdat.defaultImage.name"
                      [alt]="cartdat.defaultImage.name">
                    <img *ngIf="urlvideo(cartdat.defaultImage)" [src]="cartdat.defaultImage"
                      [alt]="cartdat.defaultImage">
                  </figure>
                  <div class="content-activity">
                    <h2 data-toggle="tooltip" [title]="cartdat?.name" (click)="clickOnNameRoute(cartdat)"
                      class="cursorHand">
                      {{cartdat?.name}}
                    </h2>
                    <!--                            <span class="d-flex profile-small align-items-center"><img src="assets/images/activity-images.png" alt="activity images"><span>by Ayesha Billimoria</span></span>-->
                    <p *ngIf="cartdat?.type === 'shop'" style="margin-bottom:2px;">

                      <span>
                        {{cartdat?.attr?.weight}} {{ cartdat?.attr?.weight ? ' gms' : ''}}
                        {{cartdat?.attr?.size && cartdat?.attr?.weight ? " | ": "" }}
                        {{cartdat?.attr?.size}}
                        {{ cartdat?.attr?.weight && (cartdat?.attr?.size && cartdat?.attr?.color ) ? " | ": "" }}
                        {{cartdat?.attr?.color }}
                        {{ (cartdat?.attr?.weight || cartdat?.attr?.size || cartdat?.attr?.color ) &&
                        cartdat?.attr?.flavour ? " | ": "" }}
                        {{cartdat?.attr?.flavour }}
                      </span>
                    </p>
                    <p *ngIf="cartdat?.type === 'shop'">
                      <span *ngIf="cartdat?.itineraryData?.quantity">
                        Qty: {{cartdat?.itineraryData?.quantity }}
                      </span>
                    </p>
                    <p *ngIf="cartdat?.type === 'shop'">
                      <span *ngIf="!shippingInsideUsaFlag" class="fontSize10"
                        [style.color]="( cartdat?.attr?.shippingOutUSA !== null &&  cartdat?.attr?.shippingOutUSA !== '' && cartdat?.attr?.shippingOutUSA >= 0 ) ? '': 'red'">
                        Shipping
                        {{ ( cartdat?.attr?.shippingOutUSA !== null && cartdat?.attr?.shippingOutUSA !== '' &&
                        cartdat?.attr?.shippingOutUSA >=0 ) ? "available !!" : "not available on selected country." }}
                        <span
                          *ngIf="( cartdat?.attr?.shippingOutUSA !== null &&  cartdat?.attr?.shippingOutUSA !== '' && cartdat?.attr?.shippingOutUSA >=0 )">
                          ( {{ cartdat?.attr?.shippingOutUSA | currency:'USD':'symbol':'1.2-2' }} )
                        </span>
                      </span>
                      <span *ngIf="shippingInsideUsaFlag" class="fontSize10"
                        [style.color]="( cartdat?.attr?.shippingInUSA !== null && cartdat?.attr?.shippingInUSA !== '' && cartdat?.attr?.shippingInUSA >=0 ) ? '': 'red'">
                        Shipping
                        {{ ( cartdat?.attr?.shippingInUSA !== null && cartdat?.attr?.shippingInUSA !== "" &&
                        cartdat?.attr?.shippingInUSA >=0 ) ? "available !!" : "not available on selected country." }}
                        <span
                          *ngIf="( cartdat?.attr?.shippingInUSA !== null &&  cartdat?.attr?.shippingInUSA !== '' && cartdat?.attr?.shippingInUSA >=0 )">
                          ( {{ cartdat?.attr?.shippingInUSA | currency:'USD':'symbol':'1.2-2' }} )
                        </span>
                      </span>
                    </p>
                    <strong>{{cartdat.itineraryData.totalPayPrice | currency:'USD':'symbol':'1.2-2'}}</strong>
                  </div>
                  <a (click)="deletecartitemlive(cartdat.cartId)" class="cursorHand">
                    <i class="icon-cross"></i>
                  </a>
                </li>
              </ul>
            </div>
            <div class="final-checkout">
              <h2 class="text-capitalize">Price Details</h2>
              <ul class="total-summary">
                <li class="d-flex justify-content-between align-items-center">
                  <span>Subtotal</span>
                  <strong *ngIf="cartdata && !logstatus">{{subtotal | currency:'USD':'symbol':'1.2-2'}}</strong>
                  <strong *ngIf="logstatus && cartdata">{{subtotal | currency:'USD':'symbol':'1.2-2'}}</strong>
                </li>
                <li class=" d-flex justify-content-between align-items-center" *ngIf="cartdata && traveladdons > 0">
                  <span>Addons</span>
                  <strong>{{traveladdons | currency:'USD':'symbol':'1.2-2'}}</strong>
                </li>
                <li class="total-info d-flex justify-content-between align-items-center" *ngIf="discountedAmount">
                  <strong>
                    Discount
                    <div *ngIf="couponInfo?.appliedFor">
                      <span class="fontSize12  fontItalic">
                        Applied For {{ couponInfo?.appliedFor }} products.
                      </span>
                    </div>
                    <div *ngIf="couponInfo?.description">
                      <span class="fontSize12  fontItalic">
                        {{ couponInfo?.description }}
                      </span>
                    </div>
                  </strong>
                  <strong class="final-price">{{discountedAmount | currency:'USD':'symbol':'1.2-2'}}</strong>
                </li>
                <li class="total-info d-flex justify-content-between align-items-center" *ngIf="loyalityPointsAmount">
                  <strong>Points Discount</strong>
                  <strong class="final-price">{{loyalityPointsAmount | currency:'USD':'symbol':'1.2-2'}}</strong>
                </li>
                <li class=" d-flex justify-content-between align-items-center" *ngIf="cartdata">
                  <span>Handling Fee(2.9%)</span>
                  <strong>{{(totalamount*0.029) | currency:'USD':'symbol':'1.2-2'}}</strong>
                </li>
                <!-- SHIPPING CHARGE START -->
                <li class="d-flex justify-content-between align-items-center" *ngIf="shippingCharge > 0">
                  <span>Shipping Charge</span>
                  <strong>{{shippingCharge | currency:'USD':'symbol':'1.2-2'}}</strong>
                </li>
                <!-- SHIPPING CHARGE END -->
                <li class="total-info d-flex justify-content-between align-items-center">
                  <strong>Order Total</strong>
                  <strong class="final-price">{{gettotalwithhandling() | currency:'USD':'symbol':'1.2-2'}}</strong>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div>
    </div>
  </mat-step>
</mat-horizontal-stepper>

<div class="enquiry-poup">
  <app-modal-pop-up [responseMessage]="responseMessages" *ngIf="showAlert" (triggerCloseEvent)="triggerCloseEvent()">
  </app-modal-pop-up>
</div>
<!-- update trip popup -->


<!-- The Modal For Billing Address Selection-->
<div id="myModalForBilling" class="modal" *ngIf="billingAddressCheck">
  <div class="modal-content ">
    <h2 class="popup-title">
      Saved Addresses:
    </h2>
    <span class="close" style="text-align: end;">
      <a class="cursorHand" (click)="billingAddressCheck = false">&times;</a>
    </span>
    <div class="input-grp d-flex flex-wrap" *ngIf="addressData  && addressData.length>0  && billingAddressCheck">
      <div class="card-item cursorHand" *ngFor="let i of addressData;let ind = index;"
        (click)="billingAddressSelectedFromList(i);selectedIndexForBillingAddress = ind">


        <div class="member-txt">
          {{i?.label}}
          <i *ngIf="selectedIndexForBillingAddress == ind" class="icon-check checkIcon floatRight"></i>
        </div>
        <p class="address">
          {{ i?.address?.FirstName }} {{i?.address?.LastName}}

        </p>
        <a class="email-id2">
          {{ i?.address?.address }} {{ ( i?.address?.address && i?.address?.City ) ? ", " : "" }}
          {{ i?.address?.City }} {{ i?.address?.City ? ", " : "" }}
          {{ i?.address?.Country }} {{ i?.address?.Country ? ", " : ""}}
          {{ i?.address?.State }} {{ (i?.address?.State && i?.address?.Zipcode) ? ", " : ""}}
          {{ i?.address?.Zipcode }}
        </a>

      </div>
    </div>
    <div class="textAlignEnd">
      <button class="btn okButtonCss" (click)="billingAddressCheck = false;countryUpdateInBillingForm()">
        OK
      </button>
    </div>
  </div>
</div>
<!-- Modal for SHIPPING ADDRESS Selection -->
<div id="myModalForShipping" class="modal" *ngIf="openShippingAddressPopUpFlag">
  <div class="modal-content ">
    <h2 class="popup-title">
      Saved Addresses:
    </h2>
    <span class="close" style="text-align: end;">
      <a class="cursorHand" (click)="openShippingAddressPopUpFlag = false">&times;</a>
    </span>
    <div class="input-grp d-flex flex-wrap">
      <ng-container
        *ngIf="addressData  && addressData.length > 0 && shippingAddressListShowFlag && shippingAddressCheck">
        <div class="card-item cursorHand" *ngFor="let i of addressData;let ind = index;"
          (click)="shippingAddressSelectedFromList(i);selectedIndexForShippingAddress = ind">


          <div class="member-txt">
            {{i?.label}}
            <i *ngIf="selectedIndexForShippingAddress == ind" class="icon-check checkIcon floatRight"></i>
          </div>
          <p class="address">
            {{ i?.address?.FirstName }} {{i?.address?.LastName}}

          </p>
          <a class="email-id2">
            {{ i?.address?.address }} {{ ( i?.address?.address && i?.address?.City ) ? ", " : "" }}
            {{ i?.address?.City }} {{ i?.address?.City ? ", " : "" }}
            {{ i?.address?.Country }} {{ i?.address?.Country ? ", " : ""}}
            {{ i?.address?.State }} {{ (i?.address?.State && i?.address?.Zipcode) ? ", " : ""}}
            {{ i?.address?.Zipcode }}
          </a>

        </div>
      </ng-container>
    </div>
    <div class="textAlignEnd">
      <button class="btn okButtonCss" (click)="openShippingAddressPopUpFlag = false;countryUpdateInShippingForm()">
        OK
      </button>
    </div>
  </div>
</div>